import React, { useContext } from "react";
import { DataContext } from "../contexts/DataContext";
import Pages from "./Pages";
import DirectionButton from "./DirectionButton";

const Pagination = () => {
  const { articleListPosition, setArticleListPosition, rawArticleTotal } =
    useContext(DataContext);

  const prevHandler = (event) => {
    event.preventDefault();
    if (articleListPosition - 200 > 0) {
      setArticleListPosition(articleListPosition - 200);
    } else {
      setArticleListPosition(1);
    }
  };
  const nextHandler = (event) => {
    event.preventDefault();
    if (articleListPosition + 200 <= rawArticleTotal) {
      setArticleListPosition(articleListPosition + 200);
    } else {
      alert("exceeded");
      setArticleListPosition(rawArticleTotal - 200 + 1);
    }
  };

  const startHandler = () => {
    setArticleListPosition(1);
  };
  const endHandler = () => {
    setArticleListPosition(rawArticleTotal - 200);
  };

  return (
    <div className="pagination">
      <div className="clear"></div>
      <div className="paginator_container">
        {articleListPosition > 1 ? (
          <span className="endpoint_btn">
            <button type="button" onClick={startHandler}>
              Start
            </button>
            <span className="pagination_elipse">...</span>
          </span>
        ) : (
          <span className="endpoint_btn">
            <button type="button" className="disabled">
              Start
            </button>
          </span>
        )}
        {articleListPosition > 1 ? (
          <button type="button" onClick={(e) => prevHandler(e)}>
            &#60;
          </button>
        ) : (
          <button type="button" className="disabled">
            &#60;
          </button>
        )}
        <span>
          <Pages />
        </span>
        {articleListPosition + 200 <= rawArticleTotal ? (
          <button type="button" onClick={(e) => nextHandler(e)}>
            &#62;
          </button>
        ) : (
          <button type="button" className="disabled">
            &#62;
          </button>
        )}
        {articleListPosition + 200 <= rawArticleTotal ? (
          <span className="endpoint_btn">
            <span className="pagination_elipse">...</span>
            <button type="button" onClick={endHandler}>
              End
            </button>
          </span>
        ) : (
          <span className="endpoint_btn">
            <button type="button" className="disabled">
              End
            </button>
          </span>
        )}
      </div>
      <div className="direction_container">
        <DirectionButton />
      </div>
      <div className="clear"></div>
    </div>
  );
};

export default Pagination;
